import { combineReducers, createAction, createReducer } from "@reduxjs/toolkit";
import user, { initialState as userInitialState } from "./userReducer";
import confirmation from "./confirmationReducer";
import error from "./errorReducer";
import spinner from "./spinnerReducer";
import isDataChanged from "./isDataChangedReducer";
import isRefreshPending from "./isRefreshPendingReducer";
import layout from "./layoutReducer";
import avatar from "./avatarReducer";
import navigationData from "./navigationDataReducer";
import chats from "./chatsReducer";
import backgroundChecks from "./backgroundChecksReducer";
import branding from "./brandingReducer";
import { localStorageNameEnum } from "models/constants";

/**
 * @template T
 * @typedef {import("types/stateTypes").PayloadPreparator<T>} PayloadPreparator
 */

const appReducer = combineReducers({
  confirmation,
  error,
  user,
  spinner,
  isDataChanged,
  isRefreshPending,
  layout,
  avatar,
  navigationData,
  chats,
  backgroundChecks,
  branding,
});

export const exampleAction = createAction(
  "root/exampleAction",
  /**
   * @type {PayloadPreparator<string>}
   */
  (value) => ({ payload: value })
);

export const logoutAction = createAction("root/logout");

const rootReducer = createReducer(
  /** @type {ReturnType<typeof appReducer>} */ (undefined),
  (builder) => {
    builder
      .addCase(exampleAction, (state, { payload }) => {
        // Just an example
        // state.prop = payload
      })
      .addCase(logoutAction, (state) => {
        state.error.message = undefined;
        state.user = userInitialState;
        window.sessionStorage.removeItem(localStorageNameEnum.AUTH_TOKEN);
        window.localStorage.removeItem(localStorageNameEnum.AUTH_REFRESH_TOKEN);
      });

    builder.addDefaultCase(appReducer);
  }
);

export default rootReducer;
